<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>应用中心</el-breadcrumb-item>
            <!-- <el-breadcrumb-item>操作日志</el-breadcrumb-item> -->
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 --> 
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <!-- 侧边树 -->
      <!-- <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps" 
            default-expand-all，
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="equipType"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          >  
          </el-tree>
        </el-card>
      </el-aside> -->
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 100%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <!-- <el-row :gutter="20" type="flex" justify="space-between"> -->
          <!-- <el-col :span="6"> -->
          <div
            style=" margin: 10px 20px;display:flex;align-items: center;height:60px;justify-content: space-between;border-bottom: 1px solid #f5f5f5;"
          >  
          <div class="grid-search"  style="display:flex;align-items: center;width:50%;">
            <span>分类状态:</span>
            <ul style="display:flex;align-items: center;width:30%;justify-content: space-between;">
               <li style="" :class="active==1?'active':'' " @click="pick(1)">全部</li>
               <li :class="active==2?'active':'' "  @click="pick(2)">打卡</li>
               <li :class="active==3?'active':'' "  @click="pick(3)">考勤</li>
               <li :class="active==4?'active':'' "  @click="pick(4)">识别机</li>
            </ul>
          </div>
          <div class="grid-search">
            <el-input v-model="search.personName" placeholder="请输入名称"  clearable @input="doFilter">
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </div>
             <!-- <div class="grid-search">
              <el-input v-model="search.sn" placeholder="请输入设备sn号"  clearable @input="doFilter">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>·
             </div> -->
          </div>
          <div class="build-table">
            <div style="width:100%;display:flex;
                padding: 0 20px;;flex-wrap: wrap;height: 100%;overflow: auto;">
              <div class="block" v-for="(item,index) in productList" :key="index" >
                <div class="top">
                   <img style="width: 84px;height:84px;" :src="item.image" alt="">
                   <div>
                     <div>{{item.name}}</div>
                     <el-button v-if="item.id == 3" type="text" @click="downDrive" icon="el-icon-download">下载</el-button>
                     <el-button v-if="item.id == 4" type="text"  @click="entPro">使用域名进入应用</el-button>
                     <el-button v-if="item.id != 4 &&item.id != 3"  @click="code(item.id)" type="text" icon="el-icon-download">扫码下载</el-button>
                   </div>
                </div>
                <div class="bot">
                   <div style="font-size: 20px;">应用说明:</div>
                   <div style="font-size: 15px;">{{item.show}}</div>
                   <div style="font-size: 15px;">{{item.show2}}</div>
                   <!-- <el-button v-if="item.id == 3"   @click="more"  type="text">更多</el-button> -->
                </div>
             </div>
            </div>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <el-dialog
      :title="titledialog"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <img v-if="index==1" src="../../../assets/image/machineCode/11Code.png" alt="">
      <img v-if="index==2" src="../../../assets/image/machineCode/1nCode.png" alt="">
      <img v-if="index==5" src="../../../assets/image/machineCode/caiji.png" alt="">
      <img v-if="index==6" src="" alt="">
      <img v-if="index==7" src="../../../assets/image/machineCode/padCode.png" alt="">
      <img v-if="index==8" src="../../../assets/image/machineCode/tsTower.png" alt="">
      <img v-if="index==9" src="../../../assets/image/machineCode/tselevator.png" alt="">
      <img v-if="index==10" src="../../../assets/image/machineCode/xunfeiTower.png" alt="">
      <img v-if="index==11" src="../../../assets/image/machineCode/xunfeiEle.png" alt="">
    </el-dialog>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      index:'1',
      titledialog:'',
      active:'1',
      dialogVisible:false,
      search:{
        personName:'',
      },
      codeImg:'',
      productList:[{id:'1',
                   name:'移动定位打卡(1:1)',
                   image:require('../../../assets/image/clock.png'),
                   show:'移动定位打卡(1:1)'},
                   {id:'2',
                   name:'移动定位打卡(1:N)',
                   image:require('../../../assets/image/clock.png'),
                   show:'移动定位打卡(1:N)'},
                   {id:'3',  
                   name:'身份证阅读器',
                   image:require('../../../assets/image/idMachine.png'),
                   show:'1.安装invs-windows-ocx(全浏览器支持-带指纹).exe文件，安装目录固定在C:\CertReader',
                   show2:'2.安装完后安装程序会自动启动WebOcx.exe服务支持程序，电脑重启后服务程序也会自动重启，请确保该程序正常运行',
                  },
                  {id:'4',
                   name:'人脸拍照',
                   image:require('../../../assets/image/idMachine.png'),
                   show:'人脸拍照'},
                   {id:'5',
                   name:'采集机',
                   image:require('../../../assets/image/pickInfo.png'),
                   show:'采集机'},
                   {id:'6',
                   name:'考勤机',
                   image:require('../../../assets/image/attend.png'),
                   show:'考勤机'},
                   {id:'7',
                   name:'pad',
                   image:require('../../../assets/image/pad.png'),
                   show:'pad'},
                   {id:'8',
                   name:'瞳声塔吊',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'瞳声塔吊'},
                   {id:'9',
                   name:'瞳声升降机',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'瞳声升降机'},
                   {id:'10',
                   name:'讯飞塔吊',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'讯飞塔吊'},
                   {id:'11',
                   name:'讯飞升降机',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'讯飞升降机'}
                  
                  ],


      searchList:[{id:'1',
                   name:'移动定位打卡(1:1)',
                   image:require('../../../assets/image/clock.png'),
                   show:'移动定位打卡(1:1)'},
                   {id:'2',
                   name:'移动定位打卡(1:N)',
                   image:require('../../../assets/image/clock.png'),
                   show:'移动定位打卡(1:N)'},
                   {id:'3',  
                   name:'身份证阅读器',
                   image:require('../../../assets/image/idMachine.png'),
                   show:'1.安装invs-windows-ocx(全浏览器支持-带指纹).exe文件，安装目录固定在C:\CertReader',
                   show2:'2.安装完后安装程序会自动启动WebOcx.exe服务支持程序，电脑重启后服务程序也会自动重启，请确保该程序正常运行',
                  },
                  {id:'4',
                   name:'人脸拍照',
                   image:require('../../../assets/image/idMachine.png'),
                   show:'晟泰克汽车产品生产安谧色娜买很村村民'},
                   {id:'5',
                   name:'采集机',
                   image:require('../../../assets/image/pickInfo.png'),
                   show:'采集机'},
                   {id:'6',
                   name:'考勤机',
                   image:require('../../../assets/image/attend.png'),
                   show:'考勤机'},
                   {id:'7',
                   name:'pad',
                   image:require('../../../assets/image/pad.png'),
                   show:'pad'},
                   {id:'8',
                   name:'瞳声塔吊',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'瞳声塔吊'},
                   {id:'9',
                   name:'瞳声升降机',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'瞳声升降机'},
                   {id:'10',
                   name:'讯飞塔吊',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'讯飞塔吊'},
                   {id:'11',
                   name:'讯飞升降机',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'讯飞升降机'}
                  ],
    }
  },
  created() {
     if(util.session.get('roleId')=='4'){
      this.search.projectId = util.session.get('groupId')
      // this.search.projectId = '1226783469518934018'
    }else{
      this.search.projectId = util.session.get('proId')
    }
  },
  mounted() {

      
  },
  methods: {
    entPro(){
      window.open( 'https://sitesweb.tongsheng01.com')
    },
      //下载驱动
      downDrive(){
        
                window.open('http://filesites.tongsheng01.com/static/wisdom/plug/华视二代证读写机USB驱动.exe')
                window.open('http://filesites.tongsheng01.com/static/wisdom/plug/身份证阅读器驱动.rar')
            
        },
        code(index){
          this.dialogVisible = true
          this.index = index
          // if(index==1){
          //   // this.titledialog = '移动定位打卡(1:1)'
          // }else if(index==2){
          //   // this.titledialog = '移动定位打卡(1:N)'
          //   this.codeImg ='../../../assets/image/machineCode/1nCode.png'


          // }else if(index==5){
          //   // this.titledialog = '采集机'
          // }else if(index==6){
          //   // this.titledialog = '考勤机'
          // }else if(index==7){
          //   // this.titledialog = 'pad'
          // }
        },
    handleClose(){this.dialogVisible = false},
    doFilter(e){
    
    var searchList = this.searchList
    var result = []

    for (var i = 0; i < searchList.length; i++) { 
      // if (undefined == searchList[i].name){
      //   console.log(searchList[i])
      // }
      console.log(searchList[i].name)
      console.log(e)
      if (searchList[i].name.indexOf(e) > -1) {
  
        result.push(searchList[i])
      }

    }
    console.log(result)
     this.productList  = result
    //  console.log(  this.searchList)
     
    },
    pick(i){
      this.active = i
      if(i ==1){
        this.productList = [{id:'1',
                   name:'移动定位打卡(1:1)',
                   image:require('../../../assets/image/clock.png'),
                   show:'移动定位打卡(1:1)'},
                   {id:'2',
                   name:'移动定位打卡(1:N)',
                   image:require('../../../assets/image/clock.png'),
                   show:'移动定位打卡(1:N)'},
                   {id:'3',  
                   name:'身份证阅读器',
                   image:require('../../../assets/image/idMachine.png'),
                   show:'1.安装invs-windows-ocx(全浏览器支持-带指纹).exe文件，安装目录固定在C:\CertReader',
                   show2:'2.安装完后安装程序会自动启动WebOcx.exe服务支持程序，电脑重启后服务程序也会自动重启，请确保该程序正常运行',
                  },
                  {id:'4',
                   name:'人脸拍照',
                   image:require('../../../assets/image/idMachine.png'),
                   show:'晟泰克汽车产品生产安谧色娜买很村村民'},
                   {id:'5',
                   name:'采集机',
                   image:require('../../../assets/image/pickInfo.png'),
                   show:'采集机'},
                   {id:'6',
                   name:'考勤机',
                   image:require('../../../assets/image/attend.png'),
                   show:'考勤机'},
                   {id:'7',
                   name:'pad',
                   image:require('../../../assets/image/pad.png'),
                   show:'pad'},
                   {id:'8',
                   name:'瞳声塔吊',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'瞳声塔吊'},
                   {id:'9',
                   name:'瞳声升降机',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'瞳声升降机'},
                   {id:'10',
                   name:'讯飞塔吊',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'讯飞塔吊'},
                   {id:'11',
                   name:'讯飞升降机',
                  //  image:require('../../../assets/image/pad.png'),
                   show:'讯飞升降机'}
                  ]
      } else if(i ==2){
        this.productList = [{id:'1',
                   name:'移动定位打卡(1:1)',
                   image:require('../../../assets/image/clock.png'),
                   show:'晟泰克汽车产品生产安谧色娜买很村村民'},
                   {id:'2',
                   name:'移动定位打卡(1:N)',
                   image:require('../../../assets/image/clock.png'),
                   show:'晟泰克汽车产品生产安谧色娜买很村村民'},
                  ]
      }else if(i ==3) {
        this.productList = [  {id:'3',
                   name:'身份证阅读器',
                   image:require('../../../assets/image/idMachine.png'),
                   show:'1.安装invs-windows-ocx(全浏览器支持-带指纹).exe文件，安装目录固定在C:\CertReader',
                   show2:'2.安装完后安装程序会自动启动WebOcx.exe服务支持程序，电脑重启后服务程序也会自动重启，请确保该程序正常运行',
                  },
                  {id:'6',
                   name:'考勤机',
                   image:require('../../../assets/image/attend.png'),
                   show:'考勤机'},
                  ]
      }else{
        this.productList = [
        {id:'4',
                   name:'人脸拍照',
                   image:require('../../../assets/image/idMachine.png'),
                   show:'晟泰克汽车产品生产安谧色娜买很村村民'},
                   {id:'5',
                   name:'采集机',
                   image:require('../../../assets/image/pickInfo.png'),
                   show:'采集机'},
                   {id:'7',
                   name:'pad',
                   image:require('../../../assets/image/pad.png'),
                   show:'pad'}
                  ]
      }
    }
  }
}
</script>
<style>
/**
*图片放大右上角关闭按钮
*/
.el-image-viewer__close i{
    font-size: 4vh;
    color: #fff;
}
/* @import '../../assets/css/common.css'; */
</style>
<style scoped>
/* .content {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 1%;
} */
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}
/* .grid-search {
  display: flex;
  justify-content: space-between;
  margin: 0px 20px 0;
  height: 66px;
} */
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.build-table {
  height: calc(100% - 80px);
}
.active {
  /* background: #409eff; */
  color: #409eff;
  cursor: pointer;
}
.contract-con {
  width: 100%;
  background: #fff;
  height: 125px;
  font-size: 14px;
}
.contract-con p {
  width: 100%;
  padding: 2px 20px;
  text-align: left;
}
.content >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
  padding: 10px 0px;
}
.content >>>.el-input-group--append .el-input__inner{
  width: 200px;
}
.content >>>.el-tree{
 padding:30px;
}
.grid-search{
  margin-right: 10px;
}
.build-table  .block{
  width:25%;
  height: 300px;
  /* display: flex;
  justify-content: space-between; */
  padding: 10px;
  border: 10px solid #f5f5f5;
  border-top: 0;
    border-left: 0;
}
.top{
   display: flex;
    justify-content: space-between;
    align-items: center;
}
.bot{
  margin-top: 10px;
  text-align: left;
}
</style>